export default function MainSection({ content }) {
  return (
    <div className="div-main-admin">
      <div id="cover-spin"></div>
      <div
        className="Table"
        style={{
          width: "1024px",
          height: "100%",
          margin: "0px auto",
          top: "0px",
          background: "transperant",
        }}
      >
        <div className="Row">{content}</div>
      </div>
    </div>
  );
}
